module.exports = __webpack_public_path__ + "img/footer.aaf90182.jpg";